import { motion } from 'framer-motion';
import { Chip, ProgressBar } from '@/components/Primitives';
import { categoryChip, statusChip, formatDate } from '@/lib/format';
import { useLang } from '@/context/LanguageContext';

const cardEnter = { initial: { opacity: 0, y: 8 }, animate: { opacity: 1, y: 0 } };

// Single goal summary card used in the Goals list.
export const GoalCard = ({ goal, index = 0, onClick }) => {
  const { t, tEnum, lang } = useLang();
  const steps = goal.actionSteps || [];
  const doneSteps = steps.filter((s) => s.done).length;
  const totalSteps = steps.length;
  const nextStep = steps.find((s) => !s.done);
  return (
    <motion.button
      data-testid={`goal-card-${goal.id}`}
      initial={cardEnter.initial}
      animate={cardEnter.animate}
      transition={{ duration: 0.3, delay: index * 0.03 }}
      onClick={onClick}
      className="glass-card block w-full rounded-2xl p-4 text-left transition-transform active:scale-[0.99]"
    >
      <div className="flex items-start justify-between gap-2">
        <div className="min-w-0">
          <Chip className={categoryChip(goal.category)}>{tEnum(goal.category)}</Chip>
          <h3 className="mt-2 text-sm font-semibold text-foreground/90">{goal.title}</h3>
        </div>
        <Chip className={statusChip(goal.status)}>{tEnum(goal.status)}</Chip>
      </div>
      <div className="mt-3 flex items-center justify-between text-xs text-foreground/55">
        <span>{totalSteps > 0 ? t('goals.steps', { done: doneSteps, total: totalSteps }) : t('common.progress')}</span>
        <span className="font-mono-plex text-brand-cyan">{goal.progress}%</span>
      </div>
      <ProgressBar value={goal.progress} className="mt-1.5" />
      {nextStep ? (
        <p className="mt-2.5 line-clamp-1 text-xs text-foreground/60">
          <span className="text-brand-cyan">{t('common.next')}</span> {nextStep.text}
        </p>
      ) : null}
      {goal.deadline ? (
        <p className="mt-1 text-xs text-foreground/45">{t('goals.deadline', { date: formatDate(goal.deadline, lang) })}</p>
      ) : null}
    </motion.button>
  );
};
